export default {
    title: "Knowledge Base",
    subtitle: "Manage knowledge bases and documents for the AI agent",
    newKnowledgeBase: "New Knowledge Base",
    searchPlaceholder: "Search by name or description...",
    typePlaceholder: "Filter by type",
    headers: {
        name: "Name",
        description: "Description",
        type: "Type",
        documentCount: "Documents",
        createdAt: "Created At",
        actions: "Actions",
    },
    types: {
        general: "General",
        documents: "Documents",
        routes: "Routes",
        regulation: "Regulation",
        "company/account-specific": "Company/Account Specific",
        companyAccountSpecific: "Company/Account Specific",
    },
    actions: {
        view: "View",
        edit: "Edit",
        delete: "Delete",
        viewDocuments: "View Documents",
    },
    form: {
        new: "New Knowledge Base",
        edit: "Edit Knowledge Base",
        fields: {
            name: "Name",
            namePlaceholder: "Enter knowledge base name",
            description: "Description",
            descriptionPlaceholder: "Enter description (optional)",
            type: "Type",
            typePlaceholder: "Select type",
        },
        documents: {
            title: "Documents",
            uploadArea: "Drag files here or click to select",
            supportedFormats: "Supported formats: PDF, DOCX, TXT, MD, JSON",
            selectFile: "Select File",
            selectedFiles: "Selected files:",
            noDocuments: "No documents attached",
            remove: "Remove",
            upload: "Upload",
        },
        save: "Save",
        cancel: "Cancel",
        create: "Create",
    },
    modal: {
        confirmDelete: "Confirm Deletion",
        confirmDeleteMessage: "Are you sure you want to delete this knowledge base? This action cannot be undone.",
        cancel: "Cancel",
        delete: "Delete",
    },
    loading: "Loading...",
    noData: {
        title: "No knowledge bases available",
        message: "There are no knowledge bases to display",
        createFirst: "Create the first knowledge base",
    },
    detail: {
        title: "Knowledge Base Details",
        backToList: "Back to List",
        documents: "Documents",
        noDocuments: "No documents in this knowledge base",
        uploadDocument: "Upload Document",
    },
};
